import { render } from "./AppFooter.vue?vue&type=template&id=43522c0d"
const script = {}

import exportComponent from "/home/guenter/Entwicklung/technic-gmbh/transparent-charge-app/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__